import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CardIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="4 4 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15 8H9V10H15V8Z" />
        <path d="M9 11H15V13H9V11Z" />
        <path d="M15 14H9V16H15V14Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 4C5.89543 4 5 4.89543 5 6V18C5 19.1046 5.89543 20 7 20L17 20C18.1046 20 19 19.1046 19 18V6C19 5.0335 18.3144 4.22713 17.4031 4.04063C17.2729 4.01399 17.1381 4 17 4H7ZM7 18L7 6H17V18L7 18Z"
        />
      </svg>
    </Icon>
  );
}
